import { createClient } from '@supabase/supabase-js';

// Load environment variables (no fallbacks - fail fast if missing)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate required environment variables
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables!\n\n' +
    'Required variables:\n' +
    '  - VITE_SUPABASE_URL\n' +
    '  - VITE_SUPABASE_ANON_KEY\n\n' +
    'Please create frontend/.env file from frontend/env.template\n' +
    'See frontend/ENVIRONMENT_SETUP.md for details.'
  );
}

// Debug logs only in development mode
if (import.meta.env.DEV) {
  // console.log('✅ Supabase initialized:', {
  //   url: supabaseUrl,
  //   hasKey: !!supabaseAnonKey
  // });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);





